import { Reducer } from 'redux';
import { LEARNING_GENERATE_OUTLINE } from '../actions';

export interface GeneratedOutline {
  name: string;
  description: string;
  modules: Array<{
    name: string;
    type: string;
    duration: number;
    screens: Array<{
      title: string;
      contentPoints?: string[];
      question?: {
        text: string;
        points: number;
        options: Array<{
          text: string;
          correct: boolean;
        }>;
        hint?: string;
      };
    }>;
    maxPoints?: number;
  }>;
}

export interface GenerationSettings {
  topic?: string;
  fileId?: string;
  industry: string;
  length: string;
  includeQuiz: boolean;
  language: string;
  toneOfVoice: string;
  learningGoal: string;
  courseType: string;
}

interface GeneratedOutlineState {
  outline: GeneratedOutline | null;
  settings: GenerationSettings | null;
}

const initialState: GeneratedOutlineState = {
  outline: null,
  settings: null,
};

export const generatedOutlineReducer: Reducer<GeneratedOutlineState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case LEARNING_GENERATE_OUTLINE:
      return {
        ...state,
        outline: action.item,
        settings: action.settings,
      };
    default:
      return state;
  }
};

export default generatedOutlineReducer;
